import React from 'react'
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { format } from "date-fns";
import GlobalVariable from '../../../../services/globalVar.js';

const PurchaseReturn = (props) => {
     const parentDatas = props;
  return (
    <div className="bg-white shadow-sm chart-of-account h-100 cc-greyCard-custm1">
    <div className="row coa-header kk-header-sec">
      <div className="col-auto header-right ms-auto"></div>
    </div>

    <div className="account-table">
      <DataTable
        stripedRows
        tableStyle={{ minWidth: "100%" }}
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate="{first} to {last} of {totalRecords}"
        lazy
        value={parentDatas.purchaseReturn}
        expandedRows={parentDatas.expandedRows}
        onRowToggle={(e) => parentDatas.setExpandedRows(e.data)}
        rowExpansionTemplate={parentDatas.rowExpansionTemplatePurchaseReturn}
        emptyMessage="No data available"
      >
        <Column expander={parentDatas.allowExpansionPurchaseReturn} style={{ width: "4rem" }} />

        <Column
          field="purchaseCode"
          header=" Purchase Code "
        ></Column>
        <Column
          field="debitNoteNumber"
          header=" Debitnote Number "
        ></Column>
        <Column
          field="purchaseDate"
          header=" Purchase Date "
          body={(row) => (
              <div className="">
                   {format(
              new Date(row.purchaseDate),
              GlobalVariable.userDet.tenantConfig.dateFormat
            )}
              </div>
          )}
        ></Column>
        <Column
          field="customerName"
          header="Vendor Name"
          body={(row) => row.firstName + " " + row.lastName}
        ></Column>
        <Column
          field="companyName"
          header=" Company Name"
        ></Column>
        <Column
          field="balancePayment"
          header="Balance Payment"
          className="text-end amount-align"
          body={(row) =>
            parentDatas.currency + " " + row?.balancePayment?.toFixed(2)
          }
        ></Column>
        <Column
          field="totalAmount"
          header="Total Amount "
          className="text-end amount-align"
          body={(row) =>
            parentDatas.currency + " " + row?.totalAmount?.toFixed(2)
          }
        ></Column>
        
      </DataTable>
    </div>
  </div>
  )
}

export default PurchaseReturn